import { render, staticRenderFns } from "./InstallmentFormNiche.vue?vue&type=template&id=587836f2&"
import script from "./InstallmentFormNiche.vue?vue&type=script&lang=js&"
export * from "./InstallmentFormNiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports